import {createAction} from 'redux-actions';

import ActionTypes from './action-types';

export default {
    show: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_SHOW, (institutionId, childIds, childNames) => ({
        institutionId,
        childIds,
        childNames,
    })),
    edit: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_EDIT, (mealRegistrationId, institutionId) => ({
        mealRegistrationId,
        institutionId,
    })),
    view: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_VIEW, (mealRegistrationId, institutionId, childId) => ({
        mealRegistrationId,
        institutionId,
        childId,
    })),
    hide: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_HIDE, () => ({})),
    cancel: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_CANCEL, () => ({})),
    createFoodItem: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM, (institutionId, title) => ({
        institutionId,
        title,
    })),
    createFoodItemSuccess: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_SUCCESS, () => ({})),
    createFoodItemFailed: createAction(
        ActionTypes.MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_FAILED,
        (institutionId, title, error) => ({institutionId, title, error}),
    ),
    showFoodSelection: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_SHOW_FOOD_SELECTION, () => ({})),
    hideFoodSelection: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_HIDE_FOOD_SELECTION, () => ({})),
    foodItemSearch: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_FOOD_ITEM_SEARCH, searchTerm => ({searchTerm})),
    foodItemWriteSearch: createAction(ActionTypes.MEALS_MEAL_REGISTRATION_FOOD_ITEM_WRITE_SEARCH, searchTerm => ({
        searchTerm,
    })),
};
